import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Typed from "react-typed"
import Container from "./Container"

const HeroSection = () => {
  const data = useStaticQuery(graphql`
    query {
      thumbnail: file(relativePath: { eq: "thumbnail.jpg" }) {
        childImageSharp {
          fixed(height: 180, width: 180, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Intro>
      <ImageDiv>
        <Thumbnail fixed={data.thumbnail.childImageSharp.fixed} />
        <h1>Hello, I am Imran Sayed</h1>
      </ImageDiv>
      <Container>
        <Headline>
          <Typed
            loop
            typeSpeed={30}
            backSpeed={20}
            strings={[
              "<span class='accent'>Full Stack Developer</span>.",
              "<span class='accent'>Programming Tutor</span>.",
              "<span class='accent'>Tech Speaker.</span>",
              "<span class='accent'>Freelancer.</span>",
            ]}
            smartBackspace
            backDelay={1000}
            cursorChar="|"
            showCursor
            loopCount={0}
            className="typed"
          />
        </Headline>
      </Container>
    </Intro>
  )
}

const Intro = styled.section`
  min-height: 85vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const ImageDiv = styled.section`
  text-align: center;

  h1 {
    font-size: 2.5rem;
    margin: 20px 0;
  }

  @media screen and (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
  }

  @media screen and (max-width: 375px) {
    h1 {
      font-size: 1.8rem;
    }
  }

  @media screen and (max-width: 320px) {
    h1 {
      font-size: 1.65rem;
    }
  }
`

const Thumbnail = styled(Img)`
  border-radius: 50%;
`

const Headline = styled.h1`
  font-size: 2.5rem;
  margin: 5px 0;

  .accent {
    color: #e94e1b;
  }

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }

  @media screen and (max-width: 350px) {
    font-size: 1.8rem;
  }
`

export default HeroSection
